module.exports = __webpack_public_path__ + "img/item-arrow.7b756c3e.svg";